import {
  organisationThemeSchema,
  organisationThemeUpdateSchema,
  type OrganisationThemeUpdate,
} from "@peer-start/platform-contracts";
import { request } from "../../prototype/api/client.js";

export function fetchOrganisationTheme(organisationId: string) {
  return request(`/api/organisations/${encodeURIComponent(organisationId)}/theme`, organisationThemeSchema);
}

export function saveOrganisationTheme(organisationId: string, update: OrganisationThemeUpdate) {
  const body = organisationThemeUpdateSchema.parse(update);
  return request(`/api/organisations/${encodeURIComponent(organisationId)}/theme`, organisationThemeSchema, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
